// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_loadProgress", inline: true };
const loggerMsgs = {
  stateChange: (CHANGE) => [`load progress: ${CHANGE}`],
  error_noStateChange: () => ["No change to state provided."],
  error_invalidStateValue: (VALUE) => [`invalid state value: ${VALUE}`],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_loadProgress(CHANGES) {
  if (!("loadProgress" in CHANGES)) return this.logger("error", loggerMsgs.error_noStateChange(), "error", logArgs);

  // Setup...
  const { loadProgress } = CHANGES;
  const { progressBar, progressNumber } = this.ref;
  this.logger("state-change", loggerMsgs.stateChange(loadProgress), "default", logArgs);

  // Updt. --progress custom prop. on progress bar el...
  progressBar.style.setProperty("--progress", `${loadProgress}%`);

  // Updt. progress number el...
  progressNumber.textContent = loadProgress.toFixed(0);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
